import type { FaireProductEntity } from "../../entity_types/product";

export const p_3n4usuvekp: FaireProductEntity = {
  token: "p_3n4usuvekp",
  type: "product",
  name: "Dog Party Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/466f61f4415219b47352ae4a91be01bcb0a0d96a734d57753ed7c2ed8aec3b36.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5d23bb12c830f948d4bfbffd9f75d8f57f6282d1de21df80462b352616bbb0dc.png",
    "https://cdn.faire.com/fastly/2e94d549a13ab1c695f49d8ecda3e3d5093891f1b489603de5b05339a65a1e75.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:54.932Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
